var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?_c('div',{staticClass:"section--label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('div',{staticClass:"section"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }